import { IApplicationState } from '../types/redux';

export function banksSelector(state: IApplicationState) {
  const {
    newbuilding: { banks },
  } = state;

  return banks;
}
